import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourInsurancesApi from '@/features/dashboard/tourInsurances/api/tourInsurancesApi.ts';
import { tourInsurancesApiQueryKeys } from '@/features/dashboard/tourInsurances/api/tourInsurancesApi.queryKeys.ts';
import { TourInsurancesDto } from '@/features/dashboard/tourInsurances/types/TourInsurancesDto.ts';

export const getTourInsurancesQueryOptions = (
  tourId: string,
): UseQueryOptions<TourInsurancesDto> => ({
  queryKey: tourInsurancesApiQueryKeys.byTourId(tourId),
  queryFn: () => tourInsurancesApi.get(tourId),
  enabled: tourId !== undefined,
});

const useGetTourInsurances = (tourId: string) => {
  return useQuery(getTourInsurancesQueryOptions(tourId));
};

export default useGetTourInsurances;
